import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ICommission } from "app/auth/models/commission-interface";
import { AuthenticationService, UserService } from "app/auth/service";
import { ListService } from "app/auth/service/list.service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment";
import { IDealProductList } from "app/modules/products/models/products-deals";
import { ProductDealsService } from "app/modules/products/products-deals.service";
import { ProductsService } from "app/modules/products/products.service";
import { IProductList } from "app/modules/products/models/products";
import { ProductsCommissionsService } from "app/modules/products/products-commissions.service";
import { ProductsOrdersService } from "app/modules/products/products-orders.service";
import { ICustomer } from "../../../../customer/customer.interface";
import { CustomerService } from "../../../../customer/customer.service";

@Component({
  selector: "app-product-commission-create",
  templateUrl: "./product-commission-create.component.html",
  styleUrls: ["./product-commission-create.component.scss"],
})
export class ProductCommissionCreateComponent implements OnInit {
  @ViewChild("detailOrder") detailOrder: ElementRef;
  public contentHeader: IContentHeader;
  public formGroupDetail: FormGroup;
  public formGroupOrder: FormGroup;
  public customersList: Array<ICustomer> = [];
  public productsList: IProductList[] = [];
  public paymentsTermsList: Array<object> = [];
  public billingFrequencyList: Array<object> = [];
  public dealsList: IDealProductList[] = [];
  public dealsFilteredList: Array<IDealProductList> = [];
  public activeTab: string = "detail";
  public orderList: any = [
    {
      //On create form it will be always one order
      deal_id: null,
      deal_name: null,
      products_ids: null,
      products_names: [],
      from: null,
      to: null,
      capacity: null,
      residue: null,
      order_number: null,
      order_date: null,
      description: null,
      oder_description: null,
      payment_terms: null,
      tranche_import: null,
      tranche_number: null,
      billing_frequency: null,
      effort: null,
      daily_rate: null,
      client_approval: false,
    },
  ];
  public selectedDeal: any = null;
  public typeDeal: string = null;
  public showErrors: boolean = false;
  public dealId: number = null;
  public productsArray: Array<any> = [];
  public files_list: Array<any> = [];
  public files_list_obj: Array<any> = [];
  public attachments_list: Array<any> = [];
  public attachments_list_obj: Array<any> = [];
  public invoiceTypeList: any[] = [];
  public paymentMeasureUnitList: any[] = [];
  public setMinDateToday: boolean = false;
  private dealFromQueryParam: any = null;

  constructor(
    public _utilService: UtilsService,
    public router: Router,
    public _authService: AuthenticationService,
    public _customerService: CustomerService,
    public _formBuilder: FormBuilder,
    public _modalService: NgbModal,
    public _changeDetectorRef: ChangeDetectorRef,
    public _userService: UserService,
    private _listService: ListService,
    private activatedRoute: ActivatedRoute,
    private _productsOrdersService: ProductsOrdersService,
    private _productsService: ProductsService,
    private _productsDealsService: ProductDealsService,
    private _productsCommissionsService: ProductsCommissionsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.dealId = Number(params.deal);
    });
    this.contentHeader = {
      headerTitle: "MENU.CREATE_PRODUCT_COMMISSION",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.COMMISSION",
            isLink: true,
            link: "/dashboard/commission/list",
          },
          {
            name: "MENU.CREATE_PRODUCT_COMMISSION",
            isLink: false,
          },
        ],
      },
    };
    this.formGroupDetail = this._formBuilder.group({
      customer: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
    });
    this.formGroupOrder = this._formBuilder.group({
      deal_id: new FormControl(null, [Validators.required]),
      order_number: new FormControl(null),
      order_date: new FormControl(null),
      products_ids: new FormControl(null, [Validators.required]),
      from: new FormControl(null),
      to: new FormControl(null),
      capacity: new FormControl(null, [Validators.required]),
      residue: new FormControl(null, [Validators.required]),
      invoice_type: new FormControl(null, [Validators.required]),
      payment_measure_unit: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.maxLength(1000)]),
      order_description: new FormControl(null, [Validators.maxLength(1000)]),
      payment_terms: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      tranche_import: new FormControl(null),
      tranche_number: new FormControl(null),
      client_approval: new FormControl(false),
    });
  }

  async ngOnInit() {
    if (!this._authService.hasCapability("create_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    //List form back-end
    this.customersList = await this._customerService.getCustomers();
    this.customersList = this.customersList.sort((a, b) => (a.name > b.name ? 1 : -1));
    this.dealsList = await this._productsDealsService.getDeals();
    this.dealsList = this.dealsList.reverse();
    //If a deal has a commission is not available, so we take only deals without a commission ID
    this.dealsList = this.dealsList.filter((deals) => !deals.commission || (deals && deals.commission && !deals.commission.id));
    this.productsList = await this._productsService.getProductsList();
    this.paymentsTermsList = await this._listService.getList("payment_terms");
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    this.paymentMeasureUnitList = await this._listService.getList("payment_measure_unit");
    this.invoiceTypeList = await this._listService.getList("invoice_document_type").then((invoiceType) => invoiceType.filter((item: any)=> !item.other.credit_note))
    this.setMinDateToday = this._utilService.themeConfiguration.set_retroactive_date_commission ? false : true;

    /**If this variable is filled it's mean that the commission create was selected on deals list,
     * so we have already the customer and the deal
     **/
    if (!!this.dealId) {
      this.dealFromQueryParam = await this._productsDealsService.getDeal(this.dealId);
      this.formGroupDetail.patchValue({
        customer: this.dealFromQueryParam.client.id,
      });
      this.formGroupOrder.patchValue({
        deal_id: this.dealId,
      });
      this.filterDeals();
      await this.selectDeal();
      await this.modalOpen(this.detailOrder, null);
    }
    this._utilService.hideLoading();
  }

  ///////////////////////////////////////////////////////////////GENERAL FUNCTIONS////////////////////////////////

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroupOrder.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupOrder.controls[field_name].status === "INVALID" && this.formGroupOrder.controls[field_name].touched;
    }
  }

  resetCapacityAndResidue() {
    this.formGroupOrder.patchValue({
      capacity: null,
      residue: null,
    });
  }

  async modalOpen(modalBasic, currentOrder: any) {
    //Control if selected customer has any deals, if there aren't deals we show an error
    if (!this.dealsFilteredList || this.dealsFilteredList.length < 1) {
      await this._utilService.showSWALError({ text: "NO_DEALS_FOR_SELECTED_CUSTOMER" });
      return false;
    }
    this._modalService.open(modalBasic, {
      size: "xl",
      centered: true,
      keyboard: false,
      backdrop: false,
    });
    //If is already present an order, we patch the values for let the user edit these values
    if (!!currentOrder) {
      this.formGroupOrder.patchValue({
        deal_id: currentOrder.deal_id,
        order_number: currentOrder.order_number,
        order_date: currentOrder.order_date,
        product_id: currentOrder.product_id,
        from: currentOrder.from ? this._utilService.formatDate(currentOrder.from, "YYYY-MM-DD") : null,
        to: currentOrder.to ? this._utilService.formatDate(currentOrder.to, "YYYY-MM-DD") : null,
        capacity: currentOrder.capacity,
        residue: currentOrder.residue,
        payment_measure_unit: currentOrder.payment_measure_unit,
        invoice_type: currentOrder.invoice_type,
        description: currentOrder.description,
        order_description: currentOrder.order_description,
        payment_terms: currentOrder.payment_terms,
        billing_frequency: currentOrder.billing_frequency,
        effort: currentOrder.effort,
        daily_rate: currentOrder.daily_rate,
        tranche_import: currentOrder.tranche_import,
        tranche_number: currentOrder.tranche_number,
        client_approval: currentOrder.client_approval,
      });
    }
  }

  takeDate(event: any, field: string) {
    if (field === "from") {
      this.formGroupOrder.patchValue({
        from: event,
      });
    }
    if (field === "to") {
      this.formGroupOrder.patchValue({
        to: event,
      });
    }
    if (field === "order_date") {
      this.formGroupOrder.patchValue({
        order_date: event,
      });
    }
  }

  mcalculateSingleTrancheOnInit(discount: string, line_amount: string): string {
    if (this.formGroupOrder.value.tranche_number) {
      if (!discount) {
        if (!!line_amount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(line_amount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      } else {
        if (!!discount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(discount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      }
    } else {
      return "0,00";
    }
  }

  calculateCapacityOnInit() {
    this.resetCapacityAndResidue();
    //If is present tranche_import and tranche_number we're going to calculate capacity and residue
    if (this.productsArray && this.productsArray.length > 0) {
      this.productsArray.forEach((row) => {
        row.tranche_single_import = this.mcalculateSingleTrancheOnInit(row.discount, row.line_amount);
        if (!!this.formGroupOrder.value.tranche_number && this.formGroupOrder.value.tranche_number > 0 && !!row.tranche_single_import) {
          let capacity: number = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
          const discount: number = row.discount ? this._utilService.removeDotsFromNumber(row.discount) : 0;
          if (discount && discount !== 0) {
            //If there is a discount we're going to calculate discount divide by effort
            //Check if we have to round the value, if is it zero we don't need to round it
            let toDoMathRound: number = discount % (discount / this.formGroupOrder.value.tranche_number);
            row.tranche_single_import = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discount / this.formGroupOrder.value.tranche_number) : discount / this.formGroupOrder.value.tranche_number);
            capacity = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          } else {
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          }
        }
      });
    }
    //Adding dots to capacity and residue
    if (!!this.formGroupOrder.value.capacity && !!this.formGroupOrder.value.residue) {
      this.formGroupOrder.patchValue({
        capacity: this._utilService.addDotsToNumber(this.formGroupOrder.value.capacity),
        residue: this._utilService.addDotsToNumber(this.formGroupOrder.value.residue),
      });
    }
  }

  manageRow() {
    //Checking that a product has been deleted
    if (this.productsArray && this.productsArray.length > 0) {
      this.productsArray.map((item: any, index: number) => {
        if (item.product_id && !this.formGroupOrder.value.products_ids.includes(item.product_id)) {
          //If a product it's been removed we show an alert
          if (this.productsArray.length < 2) {
            this.productsArray.pop();
          } else {
            this.productsArray.splice(index, 1);
            this.productsArray = this.productsArray.filter((i) => i);
          }
        }
      });
    }
    //Checking that a product has been added
    if (this.formGroupOrder.value.products_ids && this.formGroupOrder.value.products_ids.length > 0) {
      this.formGroupOrder.value.products_ids.map((product_id: string, index: number) => {
        const alreadyInDatatable = this.productsArray.find((row) => row.product_id === product_id);
        if (!alreadyInDatatable) {
          this.productsArray.push({
            product_id: product_id ? product_id : null,
            product_name: this.productsList.find((product) => product.id === Number(product_id)).name,
            tranche_single_import: null,
            quantity: null,
            price: null,
          });
          const product = this.selectedDeal.deal_document.table.find((row: any) => row.product_id === product_id);
          if (!!product && !!product.price) {
            this.productsArray[index].price = product.discount ? this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(product.discount) / product.quantity) : product.price;
            this.productsArray[index].tranche_single_import = null; //Calcolo nella funzione calculate Capacity
            this.productsArray[index].discount = product.discount;
            this.productsArray[index].quantity = product.quantity;
            this.productsArray[index].line_amount = product.line_amount;
          }
        }
      });
    }
    this.calculateCapacityOnInit();
  }

  calculateMonthNumber(): number {
    const startDate: moment.Moment = moment(this.formGroupOrder.value.from);
    const endDate: moment.Moment = moment(this.formGroupOrder.value.to);
    if (!!this.formGroupOrder.value.from && !!this.formGroupOrder.value.to) {
      return Math.round(endDate.diff(startDate, "months", true));
    } else {
      return 1;
    }
  }

  calculateCapacityAndTrancheImportSingleAndGeneral(): void {
    if (this.productsArray && this.productsArray.length > 0) {
      let sumAllTrancheImport: number = 0;
      this.productsArray.map((product: any) => {
        if (!!product.price && this.formGroupOrder.value.tranche_number && product.quantity) {
          product.tranche_single_import = this._utilService.addDotsToNumber((product.quantity * this._utilService.removeDotsFromNumber(product.price)) / this.formGroupOrder.value.tranche_number);
        }
        if (!!product.tranche_single_import) {
          sumAllTrancheImport += this._utilService.removeDotsFromNumber(product.tranche_single_import);
        }
      });
      this.formGroupOrder.patchValue({
        tranche_import: this._utilService.addDotsToNumber(sumAllTrancheImport),
        capacity: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
        residue: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
      });
    }
  }

  async calculateTrancheNumberAndFrequency() {
    this.showErrors = false;
    if (this.typeDeal === "Product") {
      const startDate: moment.Moment = moment(this.formGroupOrder.value.from).clone();
      const endDate: moment.Moment = moment(this.formGroupOrder.value.to).clone();
      if (this.formGroupOrder.value.from && this.formGroupOrder.value.to) {
        if (startDate > endDate) {
          this.showErrors = true;
          await this._utilService.showSWALError({ text: "ERROR_DATE" });
          return false;
        }
        this.formGroupOrder.patchValue({
          tranche_number: endDate.diff(startDate, "months") === 0 ? 1 : Math.round(endDate.diff(startDate, "months", true)),
        });
        if (!!this.formGroupOrder.value.billing_frequency) {
          const billing: any = this.billingFrequencyList.find((i: any) => i.id === this.formGroupOrder.value.billing_frequency);
          let tranche: any = this.formGroupOrder.value.tranche_number;
          if (!!tranche) {
            this.formGroupOrder.patchValue({
              tranche_number: Math.round(tranche / billing.other.month_value),
            });
            if (this.formGroupOrder.value.tranche_number === 0) {
              this.formGroupOrder.patchValue({
                tranche_number: 1,
              });
            }
          }
        }
      }
      this.calculateCapacityAndTrancheImportSingleAndGeneral();
    }
  }

  ///////////////////////////////////////////////////////////////FORMAT MONEY FUNCTIONS////////////////////////////////

  formatMoneyValue(field: any) {
    this.formGroupOrder.patchValue({ [field]: this._utilService.addDotsToNumber(this.formGroupOrder.value[field]) });
    if (field === "capacity") {
      this.formGroupOrder.patchValue({
        //Residue it will always be filled as a capacity value
        residue: this.formGroupOrder.value.capacity,
      });
    }
  }

  formatPrice(index: number) {
    this.productsArray[index].price = this._utilService.addDotsToNumber(this.productsArray[index].price);
    this.calculateCapacityAndTrancheImportSingleAndGeneral();
  }

  //Function for filtering deals of the customer selected in detail commission
  async selectDeal() {
    //Reset product time material array
    this.productsArray = [];
    if (!!this.formGroupOrder.value.deal_id) {
      //Reset the values if the deal_id has changed
      this.formGroupOrder.patchValue({
        order_number: null,
        order_date: null,
        products_ids: null,
        from: null,
        to: null,
        capacity: null,
        residue: null,
        description: null,
        order_description: null,
        payment_terms: null,
        billing_frequency: null,
        effort: null,
        invoice_type: null,
        payment_measure_unit: null,
        daily_rate: null,
        tranche_import: null,
        tranche_number: null,
        client_approval: false,
      });
      this._utilService.showLoading();
      if (!!this.dealFromQueryParam) {
        this.selectedDeal = this.dealFromQueryParam;
        //Also the type we're going to save
        this.typeDeal = this.selectedDeal.deal_type;
        //Here if we have soma values from the deal we're going to put in our formOrder
        this.formGroupOrder.patchValue({
          billing_frequency: this.selectedDeal?.billing_frequency ? this.selectedDeal.billing_frequency : null,
          from: this.selectedDeal?.start_date ? moment(this.selectedDeal?.start_date, "YYYY-MM-DD") : null,
          to: this.selectedDeal?.end_date ? moment(this.selectedDeal?.end_date, "YYYY-MM-DD") : null,
        });
        //Here the same for the employees
        if (this.selectedDeal.products && this.selectedDeal.products.length > 0) {
          let productsIds: any = [];
          this.selectedDeal.products.map((product: any) => {
            if (!!product.id) {
              productsIds.push(product.id);
            }
          });
          this.formGroupOrder.patchValue({
            products_ids: productsIds,
          });
        }
        this._utilService.hideLoading();
        //We call changTypeDeal for resetting some values and calculate effort and add users if they are present in the selected deal
        this.changeTypeDeal();
      } else {
        await this._productsDealsService
          .getDeal(this.formGroupOrder.value.deal_id)
          .then((response: any) => {
            this.selectedDeal = response;
            //Also the type we're going to save
            this.typeDeal = this.selectedDeal.deal_type;
            //Here if we have soma values from the deal we're going to put in our formOrder
            this.formGroupOrder.patchValue({
              billing_frequency: this.selectedDeal?.billing_frequency ? this.selectedDeal.billing_frequency : null,
              from: this.selectedDeal?.start_date ? moment(this.selectedDeal?.start_date, "YYYY-MM-DD") : null,
              to: this.selectedDeal?.end_date ? moment(this.selectedDeal?.end_date, "YYYY-MM-DD") : null,
            });
            //Here the same for the employees
            if (this.selectedDeal.products && this.selectedDeal.products.length > 0) {
              let productsIds: any = [];
              this.selectedDeal.products.map((product: any) => {
                if (!!product.id) {
                  productsIds.push(product.id);
                }
              });
              this.formGroupOrder.patchValue({
                products_ids: productsIds,
              });
            }
            this._utilService.hideLoading();
            //We call changTypeDeal for resetting some values and calculate effort and add users if they are present in the selected deal
            this.changeTypeDeal();
          })
          .catch(() => {
            this._utilService.hideLoading();
            this._utilService.showSWALError({ text: "ERROR_GET_DEAL" });
          });
      }
    }
  }

  //Function for filtering deals of the customer selected in detail commission
  filterDeals() {
    if (!!this.formGroupDetail.value.customer) {
      this.dealsFilteredList = this.dealsList.filter((d) => d.client.id === this.formGroupDetail.value.customer);
    }
  }

  async goToDealsList() {
    await this.router.navigateByUrl("/dashboard/deals/list");
  }

  changeTypeDeal() {
    //Reset values before calculating
    this.productsArray = [];
    this.formGroupOrder.patchValue({
      tranche_number: null,
      tranche_import: null,
      payment_measure_unit: null,
    });
    this.manageRow();
    //Here we suggest capacity only for the first time or when deal_type change
    const defaultPayment = this.paymentMeasureUnitList.find((el) => el.name.toLowerCase().includes("numero"));
    if (!!defaultPayment) {
      this.formGroupOrder.patchValue({
        payment_measure_unit: defaultPayment.id,
      });
    }
    if (!!this.selectedDeal.tranche_number) {
      const discountDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_discounted_deal);
      const totalDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_deal);
      let importTranche: any = 0;
      if (discountDeal < totalDeal && discountDeal !== 0) {
        //If there is a discount we're going to calculate discount divide by tranche_number
        //Check if we have to round the value, if is it zero we don't need to round it
        let toDoMathRound: number = discountDeal % (discountDeal / this.selectedDeal.tranche_number);
        importTranche = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discountDeal / this.selectedDeal.tranche_number) : discountDeal / this.selectedDeal.tranche_number);
      } else {
        importTranche = this._utilService.addDotsToNumber(totalDeal / this.selectedDeal.tranche_number);
      }
      this.formGroupOrder.patchValue({
        tranche_number: this.selectedDeal.tranche_number,
        tranche_import: importTranche,
      });
      this.calculateCapacityOnInit();
    }
  }

  ///////////////////////////////////////FILES FUNCTIONS////////////////////////////
  async addFileToList(files: any) {
    //Reset variable, it will contain just one file, so if addFileToList is called we're gonna to overwrite the file list
    let updatedList: any[] = [];
    //For all files charged
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //I add the file to the list that will be uploaded later
      this.files_list.push(file);
      //I add the file to the update list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    // I updated the variable for the page
    this.files_list_obj = updatedList;
  }

  resetFilesList() {
    this.files_list_obj = [];
    this.files_list = [];
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  //Attachments functions
  async addAttachmentToList(files: any) {
    // I create a variable from the actual list
    let updatedList: any[] = this.attachments_list_obj.filter((item: any) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachments_list.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    //I update the variable for the page
    this.attachments_list_obj = updatedList;
  }

  resetAttachmentsList() {
    this.attachments_list_obj = [];
    this.attachments_list = [];
  }

  removeAttachmentFromList(index: any) {
    this.attachments_list_obj = this.attachments_list_obj.filter((item: any, i: number) => i !== index);
    this.attachments_list = this.attachments_list.filter((item: any, i: number) => i !== index);
  }

  async uploadFiles(order_id: number) {
    // I'll wait for all files to be uploaded
    await Promise.all(
      this.files_list.map((file: File) => {
        return this._productsOrdersService.uploadDocument(file, order_id);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  async uploadAttachments(order_id: number) {
    // I'll wait for all attachments to be uploaded
    await Promise.all(
      this.attachments_list.map((file: File) => {
        return this._productsOrdersService.uploadAttachment(file, order_id);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  //Function that permit to edit an order(Create's form will be only one order)
  async createOrder() {
    this._utilService.showLoading();
    if (!this._authService.hasCapability("create_order")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.showErrors = false;
    let productRowError: boolean = false;
    if (this.formGroupOrder.invalid) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }
    if (!!this.formGroupOrder.value.from && !!this.formGroupOrder.value.to) {
      //Check date
      if (moment(this.formGroupOrder.value.from) > moment(this.formGroupOrder.value.to)) {
        this._utilService.hideLoading();
        this.showErrors = true;
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        return false;
      }
    } else {
      //Se uno dei due è fillato restituisco errore, devono essere necessariamente fillati entrambi
      if (!!this.formGroupOrder.value.from || !!this.formGroupOrder.value.to) {
        await this._utilService.showSWALError({ text: "ERROR_FILL_ALL_DATES" });
        this.showErrors = true;
        return false;
      }
    }

    //Check in case product tranche_number and tranche_import
    if (!this.formGroupOrder.value.tranche_import || !this.formGroupOrder.value.tranche_number) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TRANCHE_TASK" });
      return false;
    }
    if (this.productsArray && this.productsArray.length > 0) {
      this.productsArray.map((product) => {
        if (!product.tranche_single_import || product.tranche_single_import == 0) {
          productRowError = true;
        }
      });
    }

    if (productRowError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TASK_SINGLE_TRANCHE_IMPORT" });
      return false;
    }
    //Controllo se è stato caricato un file come ordine debbano essere riempiti i campi numero ordine e data ordine
    if (this.files_list && this.files_list.length > 0) {
      if (!this.formGroupOrder.value.order_number || !this.formGroupOrder.value.order_date) {
        await this._utilService.showSWALError({ text: "ERROR_ORDER_DATE_NUMBER_REQUIRED" });
        return false;
      }
    }
    this._modalService.dismissAll();
    this.activeTab = "orders";
    this.orderList = []; //Reset before the push
    this.orderList.push({
      deal_id: this.formGroupOrder.value.deal_id,
      products_ids: this.formGroupOrder.value.products_ids,
      products_names: [],
      from: this.formGroupOrder.value.from ? moment(this.formGroupOrder.value.from).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      to: this.formGroupOrder.value.to ? moment(this.formGroupOrder.value.to).add(23, "hours").add(59, "minutes").add(59, "seconds").format("YYYY-MM-DD HH:mm:ss") : moment().format("YYYY-MM-DD"),
      capacity: this.formGroupOrder.value.capacity,
      residue: this.formGroupOrder.value.residue,
      order_number: this.formGroupOrder.value.order_number,
      order_date: !!this.formGroupOrder.value.order_date ? this.formGroupOrder.value.order_date : null,
      description: this.formGroupOrder.value.description,
      order_description: this.formGroupOrder.value.order_description,
      invoice_type: this.formGroupOrder.value.invoice_type,
      payment_measure_unit: this.formGroupOrder.value.payment_measure_unit,
      payment_terms: this.formGroupOrder.value.payment_terms,
      billing_frequency: this.formGroupOrder.value.billing_frequency,
      detail: this.productsArray,
      file: this.formGroupOrder.value.file,
      tranche_import: this.formGroupOrder.value.tranche_import,
      tranche_number: this.formGroupOrder.value.tranche_number,
      client_approval: this.formGroupOrder.value.client_approval,
      progressive_id: "#1",
    });
    //Here we're going to set a string of all users selected by the id
    if (this.formGroupOrder.value.products_ids && this.formGroupOrder.value.products_ids.length > 0) {
      this.formGroupOrder.value.products_ids.map((productId) => {
        this.orderList[0].products_names.push(this.productsList.find((e) => e.id === productId).name);
      });
      this.orderList[0].products_names = this.orderList[0].products_names.join(", ");
    }
    this._utilService.hideLoading();
  }

  async createCommission() {
    if (!this._authService.hasCapability("create_commission")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    let data: ICommission = {
      client_id: this.formGroupDetail.value.customer,
      name: this.formGroupDetail.value.name,
      order: this.orderList,
    };
    if (!!data.name) {
      data.name = data.name.trim();
    }
    if (!data.name || data.name.length < 1) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_NAME_REQUIRED" });
      return false;
    }
    await this._productsCommissionsService
      .addCommission(data)
      .then(async (res: any) => {
        //If there are files or attachments we're gonna the upload with the order_id
        if (res && res.order_id) {
          if (this.files_list && this.files_list.length > 0) {
            this._utilService.hideLoading();
            await this.uploadFiles(res.order_id);
          }
          if (this.attachments_list && this.attachments_list.length > 0) {
            this._utilService.hideLoading();
            await this.uploadAttachments(res.order_id);
          }
        }
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_COMMISSION" });
        if (!!res.commission_id) {
          await this.router.navigateByUrl(`/dashboard/commissions/edit-product-commission/${res.commission_id}`);
        } else {
          await this.router.navigateByUrl(`/dashboard/commission/list`);
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CREATE_COMMISSION" });
      });
  }
}
